import firebase from "firebase/app";
import { getCurrentUser } from "./getCurrentUser";

export const incrementUserValue = async (key) => {
  const currentUser = getCurrentUser();

  if (!currentUser) return;
  await firebase
    .firestore()
    .collection("users")
    .doc(currentUser.id)
    .update({ [key]: firebase.firestore.FieldValue.increment(1) });
};
